<template>
  <div class="page-root" id="newPolicyMenu">
    <div class="jumbotron h-100 pt-5" id="newPolicyMenu-jumbotron">
      <div class="container" id="newPolicyMenu-container">
        <div class="d-flex flex-wrap justify-content-center" id="newPolicyMenu-cardsDiv">
          
          <router-link class="card"
          v-for="(productLine, index) in enabledProductLines"       
                       :key="index"
                       :to="{
                        path: '/new/' + productLine.name.toLowerCase(),
                        query: { customerUniqueId: $route.query.customerUniqueId } 
                      }"
                       :id="'newPolicyMenu-roterId-'+productLine.description">
            <div class="card-header text-center" :id="'newPolicyMenu-cardItem-'+ productLine.description">
              {{ productLine.description }}
            </div>
          </router-link>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomIcon from '@/components/CustomIcon';
import GeneralConfigService from '../../service/GeneralConfigService';

export default {
  components: { CustomIcon },
  data() {
    return {
      enabledProductLines: []
    }
  },
  async beforeMount() {
    this.enabledProductLines = await GeneralConfigService.getEnabledProductLines();
  }
};
</script>

<style lang="scss" scoped>
.productline-icon {
  width: 80%;
  height: auto;
  fill: $primary;
}
.card-header {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 64px;
  font-weight: bold;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
}
.card-body {
  padding: 2.25rem 1.75rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;      // Center the content inside the card body
  flex-direction: column;
}
.card {
  margin: 0 5px 10px;
  flex: 1 1 200px;
  max-width: 200px;
  border: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;

  &:hover,
  &:focus {
    text-decoration: none;
    .card-header {
      background-color: $success;
    } 
    .productline-icon {
      fill: $success;
    }
  }
  @media (max-width: 991px) {
    flex: 1 1 180px;
    max-width: 180px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/new/NewPolicyMenu.vue